// extracted by mini-css-extract-plugin
export default {"home":"Complaints_home__jZdr5","home2":"Complaints_home2__89DSu","main":"Complaints_main__cvU3x","brmedium":"Complaints_brmedium__HOiEF"};